import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const communicationsStakeholderGroupsEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(
			/* webpackChunkName: "async-communications-stakeholder-groups-entrypoint" */ './src/ui/StakeholderGroupsPage'
		).then((module) => module.StakeholderGroupsPage),
	),
	getPreloadProps: () => ({}),
});
